import * as React from "react";

import primaryColour from "../../constants";

function SvgGeneric(props: React.SVGProps<SVGSVGElement>) {
  const { fill = primaryColour } = props;
  return (
    <svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.50429 12.1797C9.50429 10.7655 10.5857 9.68407 12 9.68407C12.4991 9.68407 12.8318 10.0168 12.8318 10.516C12.8318 11.0151 12.4991 11.3478 12 11.3478C11.5008 11.3478 11.1681 11.6806 11.1681 12.1797C11.1681 12.6789 10.8353 13.0116 10.3362 13.0116C9.83705 13.0116 9.50429 12.6789 9.50429 12.1797Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9601 5.66675C10.9601 5.11446 11.4078 4.66675 11.9601 4.66675H12.0398C12.5921 4.66675 13.0398 5.11446 13.0398 5.66675V6.44687C15.7784 6.92958 17.8232 9.29083 17.8232 12.1797V16.3392C18.3223 16.3392 18.6551 16.672 18.6551 17.1711C18.6551 17.6702 18.3223 18.003 17.8232 18.003H12.8319V18.8349C12.8319 19.334 12.4991 19.6668 12 19.6668C11.5008 19.6668 11.1681 19.334 11.1681 18.8349V18.003H6.17674C5.6776 18.003 5.34485 17.6702 5.34485 17.1711C5.34485 16.672 5.6776 16.3392 6.17674 16.3392V12.1797C6.17674 9.29083 8.22147 6.92959 10.9601 6.44687V5.66675ZM7.84052 16.3392V12.1797C7.84052 9.85046 9.67067 8.0203 12 8.0203C14.3293 8.0203 16.1594 9.85046 16.1594 12.1797V16.3392H7.84052Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgGeneric;
